import { colors } from '../../../../../../../colorVars';
import { Body3 } from '../../../../../../atomic/text/Text';

type Props = {
  details: {
    breakPrice: number;
  };
};

export const BreakDetailsComponent = ({ details }: Props) => {
  return (
    <td>
      <Body3 color={colors.lightGrey} fontWeight={500}>
        {'$' + details.breakPrice}
      </Body3>
    </td>
  );
};
